import { Directive, inject, OnInit } from '@angular/core';
import { Customer } from '@df/session/api/customer';
import { UiComponent } from '@df/ui/ui.component';

@Directive()
export abstract class AbstractCustomerComponent extends UiComponent implements OnInit {
    /**
     * No detach in customer area
     */
    protected override canDetach = false;

    readonly customer = inject(Customer);

    override ngOnInit(): void {
        this.subscriptions.add(this.customer.model.obs.data.subscribe(() => this.onCustomerDataChange()));
        this.onCustomerDataChange();
        super.ngOnInit();
    }

    protected onCustomerDataChange() {
        this.detectChanges();
    }
}
